// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import Es6Promise from 'es6-promise'
Es6Promise.polyfill()

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'

import VueRouter from 'vue-router'
import Router from 'vue-router'
// import VCharts from 'v-charts-v2'
import store from './store';

const echarts = require("echarts")
Vue.prototype.$echarts = echarts

Vue.prototype.window = window
Vue.use(Router);
Vue.use(ElementUI);
// Vue.use(VCharts)
Vue.config.productionTip = false

import 'font-awesome/css/font-awesome.min.css'


const routes = [
    {
        path: '/',
        component: () => import('./components/LevelOneSearch.vue'),
        children: [
            {
                path: '/',
                components: {
                    default: () => import('./components/HomeDetail.vue'),
                    left: () => import('./components/DefaultLeftBar.vue'),
                    // // 左上
                    // left1: () =>import('./components/FunctionSection.vue'),
                    // // 右上
                    // right:() =>import('./components/CommonSites.vue'),
                    lowerLeft: () => import('./components/RecentPaperSection.vue'),
                    lowerRight: () => import('./components/RecentNewsSection.vue'),
                },
                children: [
                    { path: '/', component: () => import('./components/HomeDetailHome.vue'), meta: { title: '灯塔索引 - 为您的科研、创新、梦想导航引路' } },
                    // { path: '/article/:type/:id', component: () => import('./components/ArticleDetail.vue'), props: true, meta: {title: '_'} },


                    // { path: '/articleList/:type', component: () => import('./components/ArticleList.vue'), props: true },
                    // {path: '/journal/compare/:ids', component: () => import('./components/JournalCompare.vue'), props: true},
                    // {path: '/journal/:id', component: () => import('./components/JournalDetail.vue'), props: true},
                    // { path: '/help', component: () => import('./components/HelpCenter.vue'), meta: {title: '帮助中心'} },
                    // {path: '/protocol/detail', component: () => import('./components/ProtocolDetail.vue')},
                ],
            },
            // 科研置换
            {
                path: '/exchange/list/:sort/:page',
                components: {
                    default: () => import('./components/ExchangeList.vue'),
                    left: () => import('./components/Interchange.vue')
                }
            },
            // 选刊助手
            {
                path: '/journal-guide',
                components: {
                    default: () => import('./components/JournalGuide.vue'),
                    left: () => import('./components/DefaultLeftBar.vue')
                }
            },
            {
                path: '/user_',
                components: {
                    default: () => import('./components/HomeDetail.vue'),
                    left: () => import('./components/UserCenterLeftBar.vue')
                },
                children: [
                    { path: '/user', component: () => import('./components/UserCenter.vue') },
                    // 用户中心->修改信息
                    { path: '/user/edit', component: () => import('./components/UserEditInfo.vue') },
                    // 用户中心->我的消息
                    { path: '/user/msg', component: () => import('./components/MyMessage.vue') },
                    // 用户中心->我的收藏
                    { path: '/user/col', component: () => import('./components/MyCollection.vue') },
                    //  用户中心->我的置换
                    { path: '/paper/my_replacement', component: () => import('./components/MyReplacement.vue') },
                    // 用户中心->我的润色
                    { path: '/paper/my_polish', component: () => import('./components/PaperPolishList.vue') },
                    // 用户中心->我的查重
                    { path: '/paper/my_check', component: () => import('./components/PaperCheckList.vue') },
                    // 用户中心->我的降重
                    { path: '/paper/my_dropWeight', component: () => import('./components/PaperDropWeightList.vue') },
                    // 用户中心->帮助中心
                    { path: '/help', component: () => import('./components/HelpCenter.vue') },
                ]
            },
            {
                // 论文查重
                path: '/paper/check',
                components: {
                    default: () => import('./components/PaperCheck.vue'),
                    left: () => import('./components/PaperCheckLeftBar.vue')
                },
                // 向左组件传值
                props: {
                    left: route => ({ type: 1 })
                }
            },
            {
                // 论文翻译/润色
                path: '/paper/polish',
                components: {
                    default: () => import('./components/PaperPolish.vue'),
                    left: () => import('./components/PaperCheckLeftBar.vue')
                },
                // 向左组件传值
                props: {
                    left: route => ({ type: 2 })
                }
            },
            {
                // 论文降重
                path: '/paper/dropWeight',
                components: {
                    default: () => import('./components/PaperDropWeight.vue'),
                    left: () => import('./components/PaperCheckLeftBar.vue')
                },
                // 向左组件传值
                props: {
                    left: route => ({ type: 3 })
                }
            },
            {
                path: '/graph/list/:type',
                components: {
                    default: () => import('./components/GraphList.vue'),
                    left: () => import('./components/GraphLeftBar.vue'),
                },
                props: {
                    default: true
                }
            },
            // 实用工具
            {
                path: '/tools',
                components: {
                    default: () => import('./components/ToolsList.vue'),
                    left: () => import('./components/DefaultLeftBar.vue'),
                }
            },
            {
                path: '/graph/detail/:id',
                components: {
                    default: () => import('./components/GraphDetail.vue'),
                    left: () => import('./components/GraphLeftBar.vue'),
                },
                props: {
                    default: true
                }
            },
            {
                path: '/search/:keyword',
                components: {
                    default: () => import('./components/SearchDBResult.vue'),
                    left: () => import('./components/SearchDBLeftBar.vue'),
                },
                props: {
                    default: true
                }
            },
            //  首页->最新研究
            {
                path: '/research',
                components: {
                    default: () => import('./components/ArticleList.vue'),
                    left: () => import('./components/ResearchLeftBar.vue'),
                },
                props: {
                    default: route => ({ type: 1 })
                }
            },
            // 最新研究详情
            {
                path: '/research/article/:id',
                components: {
                    default: () => import('./components/ArticleDetail.vue'),
                    left: () => import('./components/ResearchLeftBar.vue'),
                },
                props: {
                    default: route => ({ type: 1, id: route.params.id })
                }
            },
            // 新闻热点
            // {
            //     path: '/news',
            //     components: {
            //         default: () => import('./components/ArticleList.vue'),
            //         left: () => import('./components/NewsLeftBar.vue'),
            //     },
            //     props: {
            //         default: route => ({type: 2})
            //     }
            // },

            //  首页->新闻热点
            {
                path: '/articleList/:type',
                components: {
                    default: () => import('./components/ArticleList.vue'),
                    left: () => import('./components/ResearchLeftBar.vue'),
                },
                props: {
                    default: route => ({ type: 2 })
                }
                // () => import('./components/ArticleList.vue'),
            },
            // 首页->新闻热点->文章详情
            {
                path: '/article/:type/:id',
                components: {
                    // DefaultLeftBar
                    default: () => import('./components/ArticleDetail.vue'),
                    left: () => import('./components/ResearchLeftBar.vue'),
                },
                props: {
                    default: route => ({ type: 2, id: route.params.id })
                    // true, meta: {title: '_'}
                }
            },
            // 首页->统计分析->详情页
            {
                path: '/analysis/article/:id',
                components: {
                    default: () => import('./components/ArticleDetail.vue'),
                    left: () => import('./components/AnalysisLeftBar.vue'),
                },
                props: {
                    default: route => ({ type: 4, id: route.params.id })
                }
            },
            //protocol详情页
            {
                path: '/protocol/detail',
                components: {
                    default: () => import('./components/ProtocolDetail.vue'),
                    left: () => import('./components/AnalysisLeftBar.vue'),
                }
            },
            {
                path: '/journal/:id',
                components: {
                    default: () => import('./components/JournalDetail.vue'),
                    left: () => import('./components/DefaultLeftBar.vue'),
                },
                props: {
                    default: route => ({ id: route.params.id })
                }
            },
            {
                path: '/journal/compare/:ids',
                components: {
                    default: () => import('./components/JournalCompare.vue'),
                    left: () => import('./components/DefaultLeftBar.vue'),
                },
                props: true
            },
        ]
    },
    {
        path: '/a',
        component: () => import('./components/LevelOneSearchFull.vue'),
        children: [
            {
                // 统计分析
                path: '/analysis/list/:type',
                props: true,
                component: () => import('./components/AnalysisList.vue'),
            },
            {
                path: '/protocol/list/:superType/:type',
                props: true,
                component: () => import('./components/ProtocolList.vue')
            },
            {
                path: '/protocol/create',
                component: () => import('./components/ProtocolCreate.vue')
            },
            { path: '/bio-info/list/:page', component: () => import('./components/BioInfoList.vue'), props: true },
            // 人工智能
            { path: '/gpt-tools', component: () => import('./components/GptTools.vue') },
        ]
    },
    {
        path: '/b',
        component: () => import('./components/LevelOneFull.vue'),
        children: [
            {
                path: '/simple',
                component: () => import('./components/SimpleMode.vue'),
            },
        ]
    },
    {
        path: '/paper_search',
        component: () => import('./components/PaperSearchResult.vue')
    },
    {
        path: '/citations',
        component: () => import('./components/PaperSearchCitations.vue')
    },
    {
        path: '/scholar',
        component: () => import('./components/PaperSearchIndex.vue'),
        props: {
            type: 1
        }
    },
    {
        path: '/wescholar',
        component: () => import('./components/PaperSearchIndex.vue'),
        props: {
            type: 0
        }
    },
    // 官网
    {
        path: '/cytotry',
        meta:{
            title:'百科博创生物科技'
        },
        component: () => import('./components/cytotry.vue'),
    }
]

const router = new VueRouter({
    mode: 'history',
    routes // (缩写) 相当于 routes: routes
})

router.beforeEach((to, from, next) => {
    eventBus.$emit('loading', true);

    if (to.meta.title) {
        if (to.meta.title !== '_') {
            document.title = to.meta.title
        }
    } else {
        document.title = '灯塔索引'
    }

    // 在页面切换之前执行 window.stop()
    window.stop();

    // 继续导航
    next();
});

router.afterEach((to, form) => {
    // Stop the loading indicator after the route change is complete
    setTimeout(() => {
        eventBus.$emit('loading', false);
        if (to.path) {
            window._hmt.push(['_trackPageview', '/#' + to.fullPath]);
        }
    }, 1000); // Add a delay for better UX, adjust the value as needed
});

// console.log(process.env.VUE_APP_OAUTHAPI);

// 导入共用组件
import global from './utils/global.vue'
Vue.prototype.global = global

// Event bus instance
export const eventBus = new Vue();

/* eslint-disable no-new */
const vue = new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
    render: h => h(App),
    beforeCreate() {
        Vue.prototype.$bus = this
    }
})

/**
 /*对Date的扩展，将 Date 转化为指定格式的String
 /* 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
 /* 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 /* 例子：
 /* (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2019-01-02 10:19:04.423
 /* (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2019-1-2 10:19:4.18
 */
Date.prototype.Format = function (fmt) {
    var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "H+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

export default vue



// WEBPACK FOOTER //
// ./src/main.js